import { ChangeEvent, FunctionComponent } from "react";
import { Input } from "antd";

interface Props {
  fieldKey: string;
  value: number;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  minLength?: number;
}

const InputNumeric: FunctionComponent<Props> = (props) => {
  const {
    fieldKey,
    value,
    disabled,
    className,
    placeholder,
    onChange,
    maxLength,
    minLength,
  } = props;

  const handleKeypress = (e: React.KeyboardEvent) => {
    const specialCharRegex = new RegExp("[\\d]");
    const pressedKey = e.key;
    if (!specialCharRegex.test(pressedKey)) {
      e.preventDefault();
      return false;
    } else return;
  };

  return (
    <Input
      key={fieldKey}
      aria-labelledby={`${fieldKey}-label`}
      value={value}
      disabled={disabled}
      className={`${className} text-center`}
      placeholder={placeholder ?? "0"}
      onChange={onChange}
      maxLength={maxLength}
      data-test="numeric-input"
      data-test-for={fieldKey}
      min={0}
      onKeyPress={handleKeypress}
      minLength={minLength}
    />
  );
};

export default InputNumeric;
